import { Component, Input, Type, ViewChild, ViewContainerRef } from '@angular/core';

import { MapMarker } from '../../../map.enum';
import { MarkerInfoState } from '../../../shared/marker-info.state';
import { SharedMarkerFactory } from '../../../shared/shared-marker-factory.class';
import { CommunityProjectResultComponent } from './community-project-result/community-project-result.component';
import { MapSearchResultDirective } from './map-search-result.directive';
import { UserResultComponent } from './user-result/user-result.component';

@Component({
  selector: 'app-map-search-result',
  template: '<ng-template mapSearchResult></ng-template>',
})
export class MapSearchResultFactory extends SharedMarkerFactory {
  @Input({ required: false }) public override isActive = false;

  @ViewChild(MapSearchResultDirective, { static: true })
  public directive: MapSearchResultDirective;

  protected componentsMapper: { [key: string]: Type<MarkerInfoState> } = {
    [MapMarker.PROJECT]: CommunityProjectResultComponent,
    [MapMarker.COMMUNITY]: CommunityProjectResultComponent,
    [MapMarker.Organization]: UserResultComponent,
    [MapMarker.Patient]: UserResultComponent,
    [MapMarker.Doctor]: UserResultComponent,
    [MapMarker.MedStaff]: UserResultComponent,
    [MapMarker.Researcher]: UserResultComponent,
  };

  protected getViewContainer(): ViewContainerRef {
    return this.directive.viewContainerRef;
  }
}
